/** The start-of-care due window, apart from the hold logic so the seed can use it on its own. */
import type { DateKey } from "@caredna-marlin/utils/homeHealthDemo/state";
import { addDaysToKey } from "@caredna-marlin/utils/homeHealthDemo/engine/clock";

/** SOC is due inside 48 hours of the expected discharge: the day of discharge and the day after. */
export function socDueWindow(expectedDischarge: DateKey): { start: DateKey; end: DateKey } {
  return { start: expectedDischarge, end: addDaysToKey(expectedDischarge, 1) };
}

/** A seeded hold never falls outside the two days its start of care is due in. */
export function clampToSocWindow(dateKey: DateKey, expectedDischarge: DateKey): DateKey {
  const window = socDueWindow(expectedDischarge);
  if (dateKey < window.start) return window.start;
  if (dateKey > window.end) return window.end;
  return dateKey;
}
